module.exports = __webpack_public_path__ + "5378a09cb385d432e7c596e440f1b565.jpg";